import React from 'react';
import {Stack, Typography} from '@mui/material';

import {HelpSectionProps} from './types';

export function HelpSection({title, children}: HelpSectionProps) {
	return (
		<Stack gap={1}>
			<Typography variant="subheader">{title}</Typography>
			{children}
		</Stack>
	);
}
